import React from 'react'
import { Form, Input } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import constants from '../../config/constants'

import styled from 'styled-components'
import Button from '../../components/Button';

const FormItem = styled(Form.Item)`
  margin-bottom: 2.5rem;
  margin-top: 1.5rem;

  input {
    height: 45px !important;
    font-size: 16px !important;
    border: 1px solid ${constants.color.lightDark} !important;
    width: 100%;
    padding: 4px 11px;
    border-radius: 8px;
    caret-color: ${constants.color.blue} !important;

    &:focus {
      border: 1px solid ${constants.color.blue} !important;
      box-shadow: none !important;
    }
  }
`
const OtherOccupation = (props) => {

  const { getFieldDecorator } = props.form;

  const handleSubmit = e => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((err, values) => {
    if (!err) {
        props.setOtherOccupation(values.otherOccupation);
        props.setOccupation(170,null);
        props.history.go(-2)
    }
    });
  };

  const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
  };

  return (
    <Layout title={'เลือกอาชีพ'} backIcon={true} onClick={() => props.history.goBack()}>
      <h5 style={{marginTop: '2rem', marginBottom: '1rem'}}>อื่นๆ</h5>
        <Form {...formItemLayout}>
          <FormItem>
            {getFieldDecorator('otherOccupation', {
              rules: [
                {
                  required: true,
                  message: 'กรุณาระบุ',
                }
              ],
              })(<Input placeholder="กรุณาระบุ"/>)}
          </FormItem>
        </Form>
        <Button
          textcolor={constants.color.white}
          bordercolor={constants.color.orange}
          backgroundcolor={constants.color.orange}
          text={'ตกลง'}
          disabled={false}
          width={'100%'}
          onClick={handleSubmit}/>
    </Layout>
  )
}

const mapDispatchToProps = {
  setOtherOccupation: actions.setOtherOccupation,
  setOccupation: actions.setOccupation,
}

const WrappedOtherOccupation = Form.create({ name: 'otherOccupation' })(OtherOccupation);

const OtherOccupationWithConnect = connect(null, mapDispatchToProps)(WrappedOtherOccupation)

export default OtherOccupationWithConnect
